import { apiCreate, type RequestOptions } from './client'
import { PAYMENT_METHOD_UPDATE_EMAILS_TYPE, SUBSCRIPTIONS_TYPE } from './types'

/**
 * Ask for the email that carries the link to update the card behind a
 * subscription. Shopify sends it and hosts the page, so no card details come
 * anywhere near this site; the portal only says to check the inbox.
 */
export async function requestPaymentMethodUpdateEmail(
  subscriptionId: string,
  options: RequestOptions = {},
): Promise<void> {
  await apiCreate(
    '/payment_method_update_emails',
    {
      type: PAYMENT_METHOD_UPDATE_EMAILS_TYPE,
      relationships: { subscription: { data: { type: SUBSCRIPTIONS_TYPE, id: subscriptionId } } },
    },
    options,
  )
}
